var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Spinner } from "./..";
import { Button } from './Button';
var AsyncBusyButton = /** @class */ (function (_super) {
    __extends(AsyncBusyButton, _super);
    function AsyncBusyButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isBusy: false };
        _this.buttonMounted = false;
        _this.handleClick = function (ev) {
            _this.setState({ isBusy: true });
            Promise.resolve(_this.props.onClick(ev)).finally(function () {
                if (_this.buttonMounted) {
                    _this.setState({ isBusy: false });
                }
            });
        };
        return _this;
    }
    AsyncBusyButton.prototype.componentDidMount = function () {
        this.buttonMounted = true;
    };
    AsyncBusyButton.prototype.componentWillUnmount = function () {
        this.buttonMounted = false;
    };
    AsyncBusyButton.prototype.render = function () {
        return (React.createElement(BusyButton, __assign({ isBusy: this.state.isBusy }, this.props, { onClick: this.handleClick })));
    };
    return AsyncBusyButton;
}(React.Component));
var BusyButton = /** @class */ (function (_super) {
    __extends(BusyButton, _super);
    function BusyButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = React.createRef();
        _this.state = { width: undefined, height: undefined };
        return _this;
    }
    BusyButton.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        if (this.buttonRef.current &&
            prevProps.isBusy !== this.props.isBusy &&
            prevProps.children === this.props.children &&
            this.props.isBusy === true) {
            var rect = this.buttonRef.current.getBoundingClientRect();
            return { width: rect.width, height: rect.height };
        }
        return null;
    };
    BusyButton.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (snapshot !== null) {
            this.setState({
                width: snapshot.width,
                height: snapshot.height
            });
        }
    };
    BusyButton.prototype.render = function () {
        var _a = this.props, _b = _a.isBusy, isBusy = _b === void 0 ? false : _b, children = _a.children, lss = _a.lss, props = __rest(_a, ["isBusy", "children", "lss"]);
        return (React.createElement(Button, __assign({ ref: this.buttonRef, disabled: isBusy || props.disabled }, props, { lss: __assign({ width: this.state.width, height: this.state.height }, lss) }), isBusy ? React.createElement(Spinner, { height: 11 }) : children));
    };
    BusyButton.defaultProps = { minWidth: 150 };
    return BusyButton;
}(React.Component));
export { BusyButton };
BusyButton.Async = AsyncBusyButton;
//# sourceMappingURL=BusyButton.js.map